export default __webpack_public_path__ + "static/media/sweetpotato.20f30c49.png";